import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true }) || [];

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-2xl mx-auto"
        >
          <p className="font-mono-alt text-[10px] tracking-[0.3em] text-secondary">{t("faq.section_label")}</p>
          <h2 className="mt-3 font-display font-black tracking-tighter text-5xl md:text-6xl leading-[0.95]">
            {t("faq.title_l1")}
            <br />
            <span className="text-primary neon-glow-primary">{t("faq.title_l2")}</span>
          </h2>
        </motion.div>

        <div className="mt-14">
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-sm border border-primary/20 bg-card px-5 hover:border-primary/50 transition-colors data-[state=open]:border-primary/60"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-base md:text-lg hover:no-underline">
                  <span className="flex items-baseline gap-3">
                    <span className="font-mono-alt text-xs text-primary">{String(i + 1).padStart(2, "0")}</span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pl-9">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
